'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassUnavailable = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _interpolate = require('helpers/interpolate');

var _reactRouter = require('react-router');

var _CountdownTimer = require('components/CountdownTimer/CountdownTimer');

var _OfferExpiryCountdown = require('./OfferExpiryCountdown');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassUnavailable = exports.ClassUnavailable = function (_PureComponent) {
  (0, _inherits3.default)(ClassUnavailable, _PureComponent);

  function ClassUnavailable() {
    (0, _classCallCheck3.default)(this, ClassUnavailable);
    return (0, _possibleConstructorReturn3.default)(this, (ClassUnavailable.__proto__ || (0, _getPrototypeOf2.default)(ClassUnavailable)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClassUnavailable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ctaText = _props.ctaText,
          displayName = _props.displayName,
          legal = _props.legal,
          purchaseUrl = _props.purchaseUrl,
          subtitle = _props.subtitle,
          title = _props.title,
          venueName = _props.venueName;

      var interpolationConfig = {
        $USER_NAME: displayName,
        $VENUE_NAME: venueName
      };
      var promoTitle = (0, _interpolate.interpolate)(title, interpolationConfig);
      var promoSubtitle = (0, _interpolate.interpolate)(subtitle, interpolationConfig);

      return _react2.default.createElement(
        'section',
        { className: 'class-unavailable' },
        _react2.default.createElement(
          'h1',
          { className: 'class-unavailable__title' },
          promoTitle
        ),
        !!promoSubtitle && _react2.default.createElement(
          'p',
          { className: 'class-unavailable__subtitle' },
          promoSubtitle
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: purchaseUrl, className: 'class-unavailable__cta bt bt--primary mb-' },
          ctaText
        ),
        !!legal && _react2.default.createElement(
          'p',
          { className: 'class-unavailable__legal color-text-light text--sm' },
          legal
        ),
        _react2.default.createElement(_OfferExpiryCountdown.OfferExpiryCountdown, { countdownTo: (0, _CountdownTimer.nextMidnight)() })
      );
    }
  }]);
  return ClassUnavailable;
}(_react.PureComponent);

ClassUnavailable.propTypes = {
  ctaText: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string,
  legal: _propTypes2.default.string,
  purchaseUrl: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  venueName: _propTypes2.default.string
};